import { toast } from "react-toastify";
import { ShieldExclamationIcon } from "@aureskonnect/react-ui";
import React from "react";

export const showErrorToast = (message: string) => {
    toast.error(message, {
        position: toast.POSITION.TOP_CENTER,
        theme: "colored",
        icon: <ShieldExclamationIcon height={25} width={25} fill="white" />,
    });
};
